/**
 * Conversation unread helpers based on privateData.messageReadAt.
 */

export const messageCreatedAt = message => message?.attributes?.createdAt || null;
export const messageSenderId = message => message?.sender?.id?.uuid;

export const isUnreadConversation = (conversation, currentUser) => {
  const { transaction, transactionRef, latestMessage } = conversation || {};
  const currentUserId = currentUser?.id?.uuid;
  // MessagesPage stores transactionRef; denormalized rows may use transaction.
  const txId = transaction?.id?.uuid || transactionRef?.id?.uuid;
  const createdAt = messageCreatedAt(latestMessage);
  const senderId = messageSenderId(latestMessage);

  if (!currentUserId || !txId || !createdAt || senderId === currentUserId) {
    return false;
  }

  const privateData = currentUser?.attributes?.profile?.privateData || {};
  const messageReadAt = privateData.messageReadAt || {};
  const readAt = messageReadAt[txId] ? new Date(messageReadAt[txId]) : null;

  return !readAt || createdAt > readAt;
};

export const countUnreadConversations = (conversations = [], currentUser) =>
  (conversations || []).filter(c => isUnreadConversation(c, currentUser)).length;
